import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  getVisibleCategories,
  getOpenedCategories,
  getActivedCategory,
  storeCategories,
  toggleCategory,
  loadingCategories
} from '../../store/category'
import { 
  toggleCategorySidebar
} from '../../store/common'
import shop from '../../api/shop'
import { store } from '../../main.js'
import { getActiveLanguage } from 'react-localize-redux'

import CategoryItem from '../../components/CategoryItem'
import { RingLoader } from 'react-spinners'
import { Link } from 'react-router'
import { loadNewsProducts } from '../../utils/product.util'

class CategoriesContainer extends Component {
  componentWillMount () {
    /* fetch API in action */
    store.dispatch(loadingCategories(true))
    shop.getCategories(categoriesFromApi => {
      categoriesFromApi.then(cats => store.dispatch(storeCategories(cats)))
    }, 0)
  }
  render () {
    const { isLoading, categories, toggleCategory, openedCategories, activedCategory, currentLanguage, toggleCategorySidebar, isNewsOpen } = this.props
    return (
      <div>
        <RingLoader color={'#fff'} loading={isLoading} size={120} margin={'20px'} />
        <ul className='sidebar__menu'>
          {
            categories && 
            <li className={'sidebar__menu__item '+ (isNewsOpen ? 'active' : '')}>
              <Link
                to={'/category/news'}
                onClick={() => { loadNewsProducts(), toggleCategorySidebar(false) }}
              >
                {'Novinky'}
              </Link>
            </li>
          }
          {categories.filter(c => c.parent === 0).map(category => (
            <CategoryItem
              key={category.id}
              category={category}
              // routerPath={category.route[(currentLanguage ? currentLanguage : 'gb')].route}'
              routerPath={'category'}
              toggleCategory={e => toggleCategory(category.id, e)}
              toggleCategorySidebar={toggleCategorySidebar}
              categories={categories}
              openedCategories={openedCategories}
              activedCategory={activedCategory}
              currentLanguage={currentLanguage || 'gb'}
              isNewsOpen={isNewsOpen}
            />
          ))}
        </ul>
      </div>
    )
  }
}

CategoriesContainer.propTypes = {
  isLoading: PropTypes.bool,
  categories: PropTypes.shape(),
  toggleCategory: PropTypes.func,
  openedCategories: PropTypes.string,
  activedCategory: PropTypes.string,
  currentLanguage: PropTypes.string,
}

const mapStateToProps = state => ({
  categories: getVisibleCategories(state),
  openedCategories: getOpenedCategories(state),
  activedCategory: getActivedCategory(state),
  currentLanguage: getActiveLanguage(state.locale).code,
  isLoading: state.category.loadingCategories,
  isNewsOpen: state.category.news
})

const mapDispatchToProps = dispatch => ({
  toggleCategory: (id, parentId) => {
    if (parseInt(parentId) === parseInt(id)) {
      dispatch(toggleCategory(id, id))
    } else {
      dispatch(toggleCategory(parentId, id))
    }
  },
  toggleCategorySidebar: (status) => dispatch(toggleCategorySidebar(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  CategoriesContainer
)



// WEBPACK FOOTER //
// ./src/containers/Category/CategoriesContainer.js